/* eslint-disable import/prefer-default-export */
export const extractFilenameFromContentDisposition = (headers) => {
  const contentDisposition = headers['content-disposition'] || '';

  // Try to extract filename* (UTF-8 encoded, RFC 5987) first
  const filenameStarMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (filenameStarMatch) {
    return decodeURIComponent(filenameStarMatch[1]);
  }

  // Fallback to filename parameter (ASCII)
  const filenameMatch = contentDisposition.match(/filename="?([^;"]+)"?/i);
  if (filenameMatch) {
    return filenameMatch[1];
  }

  return null;
};
